import { Component } from '@angular/core';
import { SimulationLoopService } from '../../services/simulation-loop.service';
import { UserState } from '../../../state/user/user.state';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { FeaturesState } from '../../../state/features/features.state';
import { LoopSimulationStatus as ILoopSimulationStatus } from '../../interfaces/loop-simulation-status';

@Component({
  selector: 'app-simulation-loop-details',
  templateUrl: './simulation-loop-details.component.html',
  styleUrls: ['./simulation-loop-details.component.scss']
})
export class SimulationLoopDetailsComponent {
  @Select(UserState.debuggerAccess) debuggerAccess$!: Observable<boolean>;
  @Select(FeaturesState.simulationDetailsEnabled) simulationDetailsEnabled$!: Observable<boolean>;

  simulationStatus$?: Observable<ILoopSimulationStatus> = this.simulationLoopService.simulationStatus$;
  constructor(public simulationLoopService: SimulationLoopService) {}

  formatTime(timeInMs: number): string {
    const msInSecond: number = 1000;
    const msInMinute: number = 60000;
    const msInHour: number = 3600000;

    if (timeInMs < msInSecond) {
      return `${Math.floor(timeInMs)} ms`;
    }

    const seconds: number = Math.floor((timeInMs % msInMinute) / msInSecond);
    const minutes: number = Math.floor((timeInMs % msInHour) / msInMinute);
    const hours: number = Math.floor(timeInMs / msInHour);

    if (timeInMs < msInMinute) {
      return `${Math.floor(timeInMs / msInSecond)} s`;
    }

    if (timeInMs < msInHour) {
      return `${minutes} min ${seconds} s`;
    }

    return `${hours} h ${minutes} min ${seconds} s`;
  }
}
